
import { Component, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { Language } from "@/models/Language";
import api from "@/network/api";
import { AxiosResponse } from "axios";
import moment from "moment";
import { mixins } from "vue-class-component";
import DeviceType from "../../utils/DeviceUtil";
import BattleRoomType from "../../models/BattleRoomType";

@Component
export default class BattleRoom extends mixins(DeviceType) {
  @Getter("userLanguageId") private currentLanguage!: Language;

  finished: Array<BattleRoomType> = [];
  current: Array<BattleRoomType> = [];
  upcomings: Array<BattleRoomType> = [];
  countdown = 0;
  selected: BattleRoomType = {};
  isActive = false;
  schedualTab = true;
  detailsTab = false;
  Ready = false;

  get selectedDate() {
    const date = moment(this.selected.date);
    const day = `${this.$i18n.t(date.format("dddd"))}`;
    const month = `${this.$i18n.t(date.format("MMM"))}`;
    return `${day} ${date.format("DD")} ${month} ${date.format("YYYY")}`;
  }
  created() {
    api.get("battles").then((res: AxiosResponse) => {
      this.current = res.data.current;
      this.upcomings = res.data.upcoming;
      this.finished = res.data.finished;
      // set the selected to the first available current or finished or upcoming
      this.selected =
        this.current.length > 0
          ? this.current[0]
          : this.upcomings.length > 0
          ? this.upcomings[0]
          : this.finished.length > 0
          ? this.finished[0]
          : {};

      const nextBattle = this.upcomings[0];
      if (nextBattle != null) {
        const nextDate = nextBattle.date;
        const nextStartTime = nextBattle.from;

        const nextDateTime = moment.utc(
          nextDate + " " + nextStartTime,
          "YYYY-MM-DD hh:mm:ss"
        );
        const now = moment.utc();
        const secondsToEvent = nextDateTime.diff(now, "seconds");

        this.countdown = secondsToEvent;
      }
    });

    setInterval(() => {
      this.countdown--;
      if (this.countdown == 0) {
        location.reload();
      }
    }, 1000);
  }

  gohome() {
    this.$router.push("/");
  }

  setSelectedBattle(battle: BattleRoomType) {
    this.selected = battle;
    if (this.isMobile || this.isTablet || this.isMediumScreen) {
      this.schedualTab = false;
      this.detailsTab = true;
    }
  }

  attendBattle() {
    // Validate battle in progress
    if (this.current.some((battleRoom) => battleRoom.id === this.selected.id)) {
      api.post(`battles/${this.selected.id}/attend`);
    }
  }
}
